import _flatMap from 'lodash/flatMap';
import _reduce from 'lodash/reduce';
import _difference from 'lodash/difference';
import _uniq from 'lodash/uniq';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';

export const pickErrorDiff = (request, response) => {
  return _difference(request, response);
};

export const pickPromoSkus = (productData, checkForPromoSkus) => {
  const promoItemIds = _reduce(checkForPromoSkus, (prev, curr) => {
    const conditionalPromotions = productData?.[curr]?.pricing?.conditionalPromotions;

    if (!conditionalPromotions) {
      return [...prev];
    }

    const eligibilityCriteria = conditionalPromotions?.[0]?.eligibilityCriteria;

    if (eligibilityCriteria) {
      const allOmsSkus = _flatMap(eligibilityCriteria, (criteria) => criteria.omsSkus);
      return [...prev, ...allOmsSkus];
    }

    return [...prev];
  }, []);

  const diff = _difference(_uniq(promoItemIds), Object.keys(productData));

  if (_isEmpty(diff)) {
    return null;
  }

  return diff;
};

export const addFulfillment = (skuData, fulfillmentData) => _map(skuData, (item) => ({
  ...item,
  fulfillment: fulfillmentData?.[item?.itemId]?.fulfillment || { fulfillmentOptions: null }
}));
